import subscription from '../../en/pages/subscription';

export default {
    ...subscription,
    pricing: {
        ...subscription.pricing,
        currency: "$"
    }
};
